import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then((m) => m.adminRoutes)
  },
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then((m) => m.HomePage)
  },
  {
    path: 'blog',
    loadComponent: () => import('./pages/blog/blog').then((m) => m.BlogPage)
  },
  {
    path: 'article/:slug',
    loadComponent: () => import('./pages/article/article').then((m) => m.ArticlePage)
  },
  {
    path: 'languages',
    loadComponent: () => import('./pages/languages/languages').then((m) => m.LanguagesPage)
  },
  {
    path: 'languages/:lang',
    loadComponent: () => import('./pages/languages/languages').then((m) => m.LanguagesPage)
  },
  {
    path: 'links',
    loadComponent: () => import('./pages/links/links').then((m) => m.LinksPage)
  },
  {
    path: 'dictionaries',
    loadComponent: () => import('./pages/dictionaries/dictionaries').then((m) => m.DictionariesPage)
  },
  { path: '**', redirectTo: '' }
];
